<template>
  <div class="basic_banner_box my_banner">
    <!-- v-if="!infor.title.text.isHidden"-->
    <div class="tooptipPart module_edit_btn">
      <my_edit_btn :module="module"></my_edit_btn>
      <template v-if="$store.state.app.view_pattern === 'pc'">
        <my_edit_btn :module="module" tabName="animation"></my_edit_btn>
        <my_close_btn :module="module" :column="column" :moduleIndex="module_index"></my_close_btn>
      </template>
    </div>
    <my_title_index :title="infor.title"></my_title_index>
    <!--轮播图展示部分-->
    <div
      class="basic_banner_swiper_box"
      :style="{
      width:$store.state.app.view_pattern === 'pc' ? pc_infor.img_size[pc_infor.img_size.radio_val].width : '100%',
    }"
      :class="module.data.listArr.module_style == '3' ? 'basic_banner_swiper_coverflow' : ''"
      data-comb-dom
    >
      <div
        class="basic_banner_swiper_box_height"
        :style="{
        paddingBottom:pc_infor.img_size[pc_infor.img_size.radio_val].height,
      }"
      >
        <div class="basic_banner_child">
          <swiper
            ref="mySwiper"
            class="basic_banner_swiper"
            v-if="$store.state.app.basic_banner_isRender"
            :options="swiperOption"
          >
            <swiper-slide v-for="(item,i) in imgs" :key="i" class="list_one">
              <div
                class="animationBox"
                ref="animationBox"
                style="height: 100%"
                @mouseenter="enter_animation"
                @mouseleave="leave_animation"
              >
                <div
                  class="back_img animationImg"
                  :style="{
                  backgroundImage:'url(' + item.img_path + ')',
                  backgroundSize:pc_infor.backgroundSize.radio_val === 'default' ? pc_infor.backgroundSize.default.backgroundSize : pc_infor.backgroundSize.custom.backgroundSize
                }"
                ></div>
                <div
                  class="my_photo_desc"
                  v-if="item.summary && infor.alt_display == 'true'"
                  :class="[
                  module.data.listArr.module_style == '2' ? 'particularly_high' : '',
                  pc_infor.banner_set.radio_val == 'custom' && $store.state.app.view_pattern == 'mb' ? 'special_particularly_high' : ''
                  ]"
                >
                  <span class="wb-normal">{{item.summary}}</span>
                </div>
                <set_link class="linkPart" :sendData="item.intro"></set_link>
              </div>
              <div
                class="tooptipPart one_img_tooptipPart"
                v-if="$store.state.app.view_pattern === 'pc' && item.img_type == 'custom'"
                @click.stop
              >
                <my_hover_btn :tips="$t('widgets_basic_banner_index_439')" btnIcon="el-icon-edit" @changeStyle="edit_one(item)"></my_hover_btn>
                <my_hover_btn :tips="$t('widgets_basic_banner_index_440')" btnIcon="el-icon-close" @changeStyle="del_one(i)"></my_hover_btn>
              </div>
            </swiper-slide>
          </swiper>
        </div>
      </div>
      <!--块级按钮-->
      <template v-if="module.data.listArr.module_style == '1'">
        <div class="pic_arrow_btn_prev banner_btn" @click="banner_prev"></div>
        <div class="pic_arrow_btn_next banner_btn" @click="banner_next"></div>
      </template>

      <!--相册按钮-->
      <template v-if="module.data.listArr.module_style == '3'">
        <div class="coverflow_btn_prev coverflow_btn" @click="banner_prev">
          <div class="pic_arrow_btn_prev banner_btn"></div>
        </div>
        <div class="coverflow_btn_next coverflow_btn" @click="banner_next">
          <div class="pic_arrow_btn_next banner_btn"></div>
        </div>
      </template>
    </div>

    <!-- 下部分页器 -->
    <template v-if="module.data.listArr.module_style == '0'">
      <div class="pagination_frame">
        <ul class="paginations">
          <li
            class="page"
            v-for="(item,i) in imgs"
            :key="i"
            :class="i == index ? 'active' : ''"
            data-comb-dom
          >
            <div class="photo_mask" @click="page_change(i)"></div>
            <div
              class="photo_item fkw_img_lazyload"
              :style="{
            backgroundImage:'url(' + item.img_path + ')'
            }"
            ></div>
          </li>
        </ul>
      </div>
    </template>

    <!-- 点分页器 -->
    <template v-if="module.data.listArr.module_style == '2'">
      <ul class="basic_banner_dot_list" :class="pc_infor.banner_set.radio_val == 'custom' || pc_infor.banner_set.radio_val == 'default'? 'pages_custom' : ''">
        <li
          class="select_photo"
          v-for="(item,i) in imgs"
          :key="i"
          :class="index == i ? 'active' : ''"
          @click="page_change(i)"
        ></li>
      </ul>
    </template>
  </div>
</template>

<script>
import i18n from '../../language/index'

export default {
  name: "basic_banner",
  data() {
    return {
      index: 0,
      imgs: [],
      loading: false
    };
  },
  props: {
    module: {
      type: Object,
      default: null
    },
    column: {
      type: Object,
      default: null
    },
    row: {
      type: Object,
      default: null
    },
    module_index: {
      type: Number,
      default: 0
    }
  },
  methods: {
    changeStyle(tabName) {
      this.templet.changeStyle(this.module);
      this.$store.commit("main_dialog/set_tabs_name", "style");
    },
    page_change(i) {
      this.$refs.mySwiper.swiper.slideTo(i, 300, false);
      this.btn_scroll(i);
    },
    btn_scroll(i) {
      const id = this.module.widgets_id;
      const dom = $(`#u${id}`).find(".pagination_frame");
      const end_offset =
        $(".pagination_frame")
          .find(".page")
          .outerWidth(true) * i;
      const pagination_frame_w = dom.width();
      const left = (pagination_frame_w - 100) / 2;
      dom.animate(
        {
          scrollLeft: `${end_offset - left}px`
        },
        200
      );
    },
    banner_prev() {
      this.$refs.mySwiper.swiper.slidePrev();
    },
    banner_next() {
      this.$refs.mySwiper.swiper.slideNext();
    },
    edit_one(item) {
      this.$store.commit("image_upload/set_fileType", 1);
      this.$store.commit("image_upload/set_showTag", true);
      this.$store.commit("image_upload/set_fileLimit", 1);
      this.$store.state.image_upload.imgFile = e => {
        if (e && e instanceof Array && e.length > 0) {
          item.img_path = e[0].filePath;
        }

        this.$store.state.image_upload.imgFile = null;
      };
    },
    del_one(i) {
      if (this.imgs.length <= 1) {
        this.$message.error({
          showClose: true,
          message: i18n.t('widgets_basic_banner_index_441')
        });
        return;
      }
      this.$confirm(i18n.t('widgets_basic_banner_index_442'), "", {
        confirmButtonText: i18n.t('view_public_topbar_24'),
        cancelButtonText: i18n.t('view_public_topbar_11'),
        center: true,
        // customClass: "del_dialog",
        appendToBody: true
      })
        .then(() => {
          this.imgs.splice(i, 1);
        })
        .catch(() => {});
    },
    enter_animation(e) {
      this.templet.enter_animation(
        this.img_effects,
        e.target,
        this.$store.state.app.view_pattern
      );
    },
    leave_animation(e) {
      this.templet.leave_animation(this.img_effects, e.target);
    }
  },
  watch: {
    "module.data.listArr.type"(val) {
      this.templet.imgs_init(this);
    },
    "module.data.listArr.atlas_id"(val) {
      this.templet.imgs_init(this);
    },
    "module.data.listArr.custom"(val) {
      this.templet.imgs_init(this);
    }
  },
  computed: {
    infor() {
      return this.module.data[
        this.$store.state.app.view_pattern + "_widgets_infor"
      ];
    },
    pc_infor() {
      return this.module.data.pc_widgets_infor;
    },
    swiperOption() {
      const obj = {
        myVm: this,
        loop: this.module.data.listArr.module_style == "3" ? true : false,
        direction: "horizontal",
        effect:
          this.module.data.listArr.module_style == "3" ? "coverflow" : "slide",
        simulateTouch: false,
        observer: true,
        observeParents: true,
        centeredSlides:
          this.module.data.listArr.module_style == "3" ? true : false,
        slidesPerView:
          this.module.data.listArr.module_style == "3" ? "auto" : 1,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 200,
          modifier: 3,
          slideShadows: false
        },
        on: {
          slideChange: function(e) {
            const that = this.passedParams.myVm;
            that.index = this.activeIndex;
            that.btn_scroll(that.index);
          },
          init: function() {
            const that = this.passedParams.myVm;
            that.index = 0;
          }
        }
      };

      const autoplay = this.templet.autoplay_obj(
        this.module.data.pc_widgets_infor.banner_set,
        obj
      );
      obj.autoplay = autoplay;
      return obj;
    },
    img_effects() {
      return this.module.data.img_effects;
    }
  },
  created() {
    this.templet.imgs_init(this);
  },
  mounted() {
    this.templet.initImageAnimation(
      this.img_effects,
      this.img_effects,
      this.$refs.animationBox,
      this.$store.state.app.view_pattern
    );
  }
};
</script>

<style scoped lang="scss">
.basic_banner_box {
  width: 100%;
}

.basic_banner_swiper_box {
  margin: 0 auto;
  position: relative;

  .basic_banner_swiper_box_height {
    position: relative;

    .basic_banner_child {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 10;

      .basic_banner_swiper {
        width: 100%;
        height: 100%;
        .list_one {
          .tooptipPart {
            right: 0;
            bottom: 0;
            top: auto;
            display: none;
            z-index: 1996;
          }
        }
        .list_one:hover .tooptipPart {
          display: block;
        }

        .back_img {
          width: 100%;
          height: 100%;
          background-position: center;
          background-repeat: no-repeat;
        }
      }

      /* /deep/ .swiper-slide {
          width: 100% !important;
        } */
    }
  }
}

.pagination_frame {
  display: flex;
  display: -webkit-flex;
  display: -ms-flexbox;
  overflow-y: hidden;
  overflow-x: auto;
  // scrollbar-color: transparent transparent;
  // scrollbar-track-color: transparent;
  // -ms-scrollbar-track-color: transparent;

  .paginations {
    white-space: nowrap;
    /*width: 100%;*/
    font-size: 0;
    margin: 0 auto;

    .page {
      position: relative;
      display: inline-block;
      width: 100px;
      height: 75px;
      margin: 18px 9px;
      -webkit-box-sizing: border-box;
      -moz-box-sizing: border-box;
      box-sizing: border-box;
      -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

      .photo_mask {
        cursor: pointer;
        position: absolute;
        z-index: 2;
        width: 100%;
        height: 100%;
        background: rgba(255, 255, 255, 0.3);
        -webkit-transition: all 0.3s;
        -o-transition: all 0.3s;
        -moz-transition: all 0.3s;
        transition: all 0.3s;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
      }

      .photo_mask:hover {
        background: 0 0;
      }

      .photo_item {
        height: 100%;
        -moz-background-size: cover !important;
        -o-background-size: cover !important;
        background-size: cover !important;
        background-position: center;
        padding-bottom: 75%;
      }
    }

    .active {
      .photo_mask {
        border: 1px solid grey;
        background: 0 0;
      }
    }
  }
}

.pagination_frame::-webkit-scrollbar {
  height: 0px;
}

.pic_arrow_btn_prev {
  left: 20px;
}

.pic_arrow_btn_next {
  right: 20px;
  background-position: -45px 0;
}

.basic_banner_dot_list {
  text-align: center;
  position: absolute;
  bottom: 7px;
  width: 100%;
  z-index: 99;

  .select_photo {
    display: inline-block;
    width: 9px;
    height: 9px;
    background: rgba(153, 153, 153, 0.8);
    margin: 7px;
    -webkit-border-radius: 50%;
    -moz-border-radius: 50%;
    border-radius: 50%;
    cursor: pointer;
    -webkit-transition: background 0.3s;
    -o-transition: background 0.3s;
    -moz-transition: background 0.3s;
    transition: background 0.3s;
  }

  .active {
    background: #fff;
  }
}

.basic_banner_swiper_coverflow {
  /deep/ .swiper-slide {
    width: 86% !important;
    transform: translateZ(0) !important;
  }

  /deep/ .swiper-slide-active {
    padding: 0 5px;
  }

  .coverflow_btn .banner_btn {
    background-color: rgba(0, 0, 0, 0);
  }

  .coverflow_btn .banner_btn:hover {
    background-color: rgba(0, 0, 0, 0.4);
  }

  .coverflow_btn {
    position: absolute;
    height: 100%;
    width: 7%;
    background-color: rgba(0, 0, 0, 0.3);
    top: 0;
    z-index: 10;
    overflow: hidden;
    cursor: pointer;
  }

  .coverflow_btn_prev {
    left: 0;

    .banner_btn {
      left: 50%;
      transform: translate(-50%) translateY(0);
    }
  }

  .coverflow_btn_next {
    right: 0;

    .banner_btn {
      right: 50%;
      transform: translate(50%) translateY(0);
    }
  }
}

.mb_pattern {
  .basic_banner_box {
    .basic_banner_swiper_coverflow {
      /deep/ .swiper-slide {
        .back_img {
          border-radius: 6px;
          overflow: hidden;
        }
      }
      .coverflow_btn {
        opacity: 0;
      }
    }
    .pagination_frame {
      overflow: hidden;
      .paginations {
        // position: relative;
        // bottom: -17px;
      }
    }
    .banner_btn {
      width: 36px;
      height: 36px;
      top: calc(50% - 13px);
      border-radius: 4px;

    }
    .pic_arrow_btn_prev{
       background-position:-10px -350px;
    }
    .pic_arrow_btn_next{
       background-position:-38px -350px;
    }
  }
}
.particularly_high {
  padding-bottom: 20px;
  box-sizing: content-box;
}
.my_banner .swiper-slide {
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/widgets/basic_banner/index.vue